import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';

import { ISelectOption } from 'components/shared/BaseFormComponents/Select/types';
import { itineraryScheduleTypeSelector } from 'store/itinerariesItem/selectors';

import { useAccomodationWizardContext } from '../../../context';
import { TAccomodationWizardData } from '../../../types';
import { getNewDisplaySettings } from '../../functions';
import type { TFormValues } from '../../types';
import { accommodationValidationSchema } from '../../validation';
import { roomToOptionAdapter } from '../functions';

export const useAccomodationForm = () => {
  const {
    updateData,
    nextStep,
    data: { default: accommodation },
  } = useAccomodationWizardContext();

  const organizedBy = useSelector(itineraryScheduleTypeSelector);
  const attachedPage = accommodation.attachedPages?.[0];

  const initialDisplaySettings = accommodation.data.displaySettings
    ? accommodation.data.displaySettings
    : getNewDisplaySettings(attachedPage?.name);

  const methods = useForm<TFormValues>({
    mode: 'onTouched',
    defaultValues: {
      id: accommodation.id,
      type: accommodation.type,
      daysRange: accommodation.daysRange,
      datesRange: accommodation.datesRange,
      attachedPage,
      icon: accommodation.icon,
      data: {
        ...accommodation.data,
        isAlternate: accommodation.data?.isAlternate,
        isCollapsible: accommodation.data?.isCollapsible,
        checkIn: accommodation.data?.checkIn,
        checkOut: accommodation.data?.checkOut,
        confirmationNumber: accommodation.data?.confirmationNumber,
        contactInfo: accommodation.data?.contactInfo,
        website: accommodation.data?.website,
        location: accommodation.data?.location,
        notes: accommodation.data?.notes,
        displaySettings: initialDisplaySettings,
        rooming: accommodation.data?.rooming?.map(roomToOptionAdapter) || [],
      },
    },
    resolver: yupResolver(accommodationValidationSchema(organizedBy)),
  });

  const onCreateOption = async (inputValue: ISelectOption) => {
    const attachedPage = {
      id: inputValue.id?.toString() || undefined,
      name: inputValue.name,
    };
    updateData('default', {
      ...accommodation,
      ...(methods.getValues() as unknown as TAccomodationWizardData['default']),
      attachedPages: [attachedPage],
      prevAttachedPage: methods.getValues('attachedPage'),
    });
    nextStep();
  };

  return { methods, onCreateOption };
};
